import React from 'react';
import RangeIndicatorChart from './RangeIndicatorChart';

interface SkinfoldBodyFatResultadoProps {
  sexo: 'M' | 'F';
  tricipitalMm: number;
  abdominalMm: number;
  coxaMm: number;
}

const getBodyFatCategoria = (sexo: 'M' | 'F', bf: number): string => {
  if (sexo === 'F') {
    if (bf < 14) return 'Atleta';
    if (bf < 21) return 'Fitness';
    if (bf < 25) return 'Aceitável';
    if (bf < 32) return 'Obesidade leve';
    return 'Obesidade severa';
  } else {
    if (bf < 6) return 'Atleta';
    if (bf < 14) return 'Fitness';
    if (bf < 18) return 'Aceitável';
    if (bf < 25) return 'Obesidade leve';
    return 'Obesidade severa';
  }
};

const getFaixas = (sexo: 'M' | 'F') => {
  if (sexo === 'F') {
    return [
      { label: 'Atleta', cor: '#90EE90', min: 0, max: 14 },
      { label: 'Fitness', cor: '#ADD8E6', min: 14, max: 21 },
      { label: 'Aceitável', cor: '#FFD700', min: 21, max: 25 },
      { label: 'Obesidade leve', cor: '#FF7F7F', min: 25, max: 32 },
      { label: 'Obesidade severa', cor: '#FF4500', min: 32, max: 100 },
    ];
  }
  return [
    { label: 'Atleta', cor: '#90EE90', min: 0, max: 6 },
    { label: 'Fitness', cor: '#ADD8E6', min: 6, max: 14 },
    { label: 'Aceitável', cor: '#FFD700', min: 14, max: 18 },
    { label: 'Obesidade leve', cor: '#FF7F7F', min: 18, max: 25 },
    { label: 'Obesidade severa', cor: '#FF4500', min: 25, max: 100 },
  ];
};

const calcularBodyFatPelaDobra = (
  sexo: 'M' | 'F',
  tricipitalMm: number,
  abdominalMm: number,
  coxaMm: number
): number => {
  if (sexo === 'F') {
    return (
      0.29669 * tricipitalMm +
      0.19055 * abdominalMm +
      0.00043 * coxaMm +
      5.4781
    );
  } else {
    return (
      0.29288 * tricipitalMm +
      0.15845 * abdominalMm +
      0.0005 * coxaMm +
      5.76377
    );
  }
};

const SkinfoldBodyFatResultado: React.FC<SkinfoldBodyFatResultadoProps> = ({
  sexo,
  tricipitalMm,
  abdominalMm,
  coxaMm,
}) => {
  if (
    !sexo ||
    !tricipitalMm ||
    !abdominalMm ||
    !coxaMm ||
    tricipitalMm <= 0 ||
    abdominalMm <= 0 ||
    coxaMm <= 0
  )
    return null;

  const bodyFat = calcularBodyFatPelaDobra(sexo, tricipitalMm, abdominalMm, coxaMm);
  const categoria = getBodyFatCategoria(sexo, bodyFat);
  const faixas = getFaixas(sexo);

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
        % Gordura Corporal: {bodyFat.toFixed(1)}% ({categoria})
      </div>
      <RangeIndicatorChart value={bodyFat} title="% Gordura Corporal" faixas={faixas} />
    </div>
  );
};

export default SkinfoldBodyFatResultado;
